<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Access Requests'"
            [description]="'Review and action pending access requests.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
            <div class="atoku-filter-bar" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
                <mat-form-field class="custom-text-field atoku-search-field" appearance="outline" floatLabel="always">
                    <mat-label>Search Requests</mat-label>
                    <input matInput (keyup)="applyFilter($event)"
                        placeholder="Search by name, card ID, reason, etc." #input>
                    <mat-icon matSuffix color="primary">search</mat-icon>
                </mat-form-field>
            </div>

          <div class="radius-10 bg-white mat-elevation-z3" fxLayout="column">
                <table mat-table class="custom-table" [dataSource]="dataSource">
                    <ng-container matColumnDef="table-label">
                        <th mat-header-cell class="custom-table-label" *matHeaderCellDef
                            [attr.colspan]="displayedColumns.length"> Access Requests </th>
                    </ng-container>

                    <ng-container matColumnDef="cardId">
                        <th mat-header-cell *matHeaderCellDef> Card ID </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.cardId}} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Name </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="surname">
                        <th mat-header-cell *matHeaderCellDef> Surname </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.surname}} </td>
                    </ng-container>

                    <ng-container matColumnDef="reason">
                        <th mat-header-cell *matHeaderCellDef> Reason </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.reason}} </td>
                    </ng-container>

                    <ng-container matColumnDef="startDate">
                        <th mat-header-cell *matHeaderCellDef> Start Date </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.startDate |
                            date:'shortDate'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="startTime">
                        <th mat-header-cell *matHeaderCellDef> Start Time </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.startTime}} </td>
                    </ng-container>

                    <ng-container matColumnDef="endDate">
                        <th mat-header-cell *matHeaderCellDef> End Date </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.endDate |
                            date:'shortDate'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="endTime">
                        <th mat-header-cell *matHeaderCellDef> End Time </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.endTime}} </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef> Actions </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element">
                            <div fxLayout="row" fxLayoutGap="8px">
                                <button mat-stroked-button color="primary" (click)="approveRequest(element)">
                                    Approve
                                </button>
                                <button mat-stroked-button color="warn" (click)="declineRequest(element)">
                                    Decline
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator #paginator class="custom-paginator" [pageSize]="10"
                    [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
            </div>
        </div>
    </div>
</div>
